import type { GalleryThumbnailProps } from "./gallery-thumbnail.type";
import type { GalleryAction } from "../gallery.type";

import { EyeOutlined } from "@ant-design/icons";
import classNames from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { GalleryThumbnailButton } from "../gallery-thumbnail-button";

import "./gallery-thumbnail.style.less";

export const GalleryThumbnail = <Data = unknown,>({
  item,
  onPreviewClick,
  extraActions,
  renderExtraActions,
}: GalleryThumbnailProps<Data>) => {
  const { t } = useTranslation();
  const [showOverlay, setShowOverlay] = useState(false);

  const onClick = () => onPreviewClick?.(item);

  const actions: GalleryAction<Data>[] = [
    {
      title: t("global:preview"),
      icon: <EyeOutlined />,
      onClick,
    },
    ...(renderExtraActions ? renderExtraActions(item) : (extraActions ?? [])),
  ];

  return (
    <div
      className={classNames("gallery-thumbnail", item.thumbnailClassName)}
      onMouseOver={() => setShowOverlay(true)}
      onMouseLeave={() => setShowOverlay(false)}
    >
      {item.node}
      <div
        onClick={onClick}
        className={classNames("gallery-thumbnail-overlay", {
          "-visible": showOverlay,
        })}
      >
        <div className="gallery-thumbnail-overlay-actions">
          {actions.map(({ key, title, icon, onClick }) => (
            <GalleryThumbnailButton
              key={key ?? title}
              title={title}
              icon={icon}
              onClick={() => onClick?.(item)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
